import React, { Component } from 'react';
import { Router, browserHistory, Route, IndexRoute } from 'react-router'
import Login from './Components/login';
import Join from './Components/join';
import Layout from './Components/Layout';
import Profile from './Components/Profile';
import Search from './Components/Search';
import Matches from './Components/Matches';
import EditPhoto from './Components/EditPhoto';
import Conversation from './Components/Conversation';
import { auth, isAuthenticated, db } from './ThirdPartyIntegration/firebaseClient'
import { config } from './config';
import './App.css';
import ReactGA from 'react-ga';

class App extends Component {
  constructor(){
    super();

    ReactGA.initialize('UA-110961207-1');
  }

  logPageView() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  requireAuth(nextState, replace) {
    if (!isAuthenticated()) {
      replace('/');
    }
  }

  componentDidMount() {
    auth.onAuthStateChanged(user => {
      if (user) {
        // update last time user logged in.
        db.ref().child(`users/${user.uid}/info/lastLoggedInOn`).set(Date.now());
        
        // retrieve the user info, make it available everywhere.
        db.ref(`users/${user.uid}/info`).on('value', snap => {
          let u = snap.val();
          let userJson = JSON.stringify(u);
          this.setState({ username: u.username });

          window.localStorage.setItem(config.localstorage.userKey, userJson);

          // if they just joined, send them to the profile page.
          if (location.pathname === '/join') {
            browserHistory.push('/loggedin/profile');
          }

          // user is already logged in.
          if(location.pathname === '/') {
            browserHistory.push('/loggedin/date');
            // TODO: if there are new matches go to matcehs
            // otherwise go to dating.
          }
        })
        this.setState({ uid: user.uid });

      } else {
        window.localStorage.removeItem(config.localstorage.userKey);
        this.setState({ uid: null });
        this.setState({ username: null });
        browserHistory.push('/');
      }
    });
  }

  render() {
    return (
        <Router history={browserHistory} onUpdate={this.logPageView}>
          <Route path="/">
            <IndexRoute component={Login}/>
            <Route path="join" component={Join} />
            {/* These require authentication */}
            <Route path="/loggedin" component={Layout} onEnter={this.requireAuth}>
              <IndexRoute component={Search}/>
              <Route path="profile" component={Profile} />
              <Route path="date" component={Search} />
              <Route path="matches" component={Matches} />
              <Route path="edit-photo" component={EditPhoto} />
              <Route path="conversation/:id" component={Conversation} />
            </Route>
          </Route>
        </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js